<script setup lang="ts">
import CustomSeparator from '@/core/elements/CustomSeparator.vue';

defineOptions({ name: 'SelectionPopoverDivider' });
</script>

<template>
  <div class="w-full px-sm py-sm">
    <CustomSeparator />
  </div>
</template>
